import { render } from "./textBox.vue?vue&type=template&id=54876c60&scoped=true"
import script from "./textBox.vue?vue&type=script&lang=js"
export * from "./textBox.vue?vue&type=script&lang=js"

import "./textBox.vue?vue&type=style&index=0&id=54876c60&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54876c60"]])

export default __exports__